(() => {
  const triggers = Array.from(document.querySelectorAll(".bb-meta-menu-trigger"));
  const drawer = document.getElementById("BBMetaMenuDrawer");
  const overlay = document.querySelector(".bb-meta-menu-overlay");

  if (!triggers.length || !drawer || !overlay) return;

  // Move overlay and drawer to body so position:fixed is relative to viewport.
  if (overlay.parentNode !== document.body) {
    document.body.appendChild(overlay);
  }
  if (drawer.parentNode !== document.body) {
    document.body.appendChild(drawer);
  }

  const closeBtn = drawer.querySelector(".bb-meta-menu-close");
  const backRow = drawer.querySelector(".bb-meta-menu-back-row");
  const backBtn = drawer.querySelector(".bb-meta-menu-back");
  const bodyPanel = drawer.querySelector(".bb-meta-menu-panel");

  const rootHTML = bodyPanel ? bodyPanel.innerHTML : "";
  const stack = [];

  const setExpanded = (val) => {
    triggers.forEach((t) => t.setAttribute("aria-expanded", String(val)));
  };

  const getScrollbarWidth = () => {
    return window.innerWidth - document.documentElement.clientWidth;
  };

  const open = (triggerEl) => {
    // 1) Lock scroll and reserve scrollbar space
    const scrollbarWidth = getScrollbarWidth();
    if (scrollbarWidth > 0) {
      document.documentElement.style.setProperty("--bb-scrollbar-gap", scrollbarWidth + "px");
    }
    document.documentElement.classList.add("bb-meta-menu-lock");

    // 2) Force header to show if it was hidden
    const header = document.querySelector(".section-header");

    if (header) {
      // Remove the hidden class that sticky-header.js adds
      header.classList.remove("section-header-hidden");
      header.classList.add("menu-open");
      
      // Get header height BEFORE changing position to fixed
      const headerHeight = header.offsetHeight;
      
      // CRITICAL: Change from sticky to fixed so header stays at viewport top
      // (sticky breaks when overflow:hidden is on body)
      header.style.position = "fixed";
      header.style.top = "0";
      header.style.left = "0";
      header.style.right = "0";
      header.style.transform = "translateY(0)";
      header.style.visibility = "visible";
      header.style.zIndex = "9999"; // Below overlay (10001) but above content
      
      // Add padding to body to compensate for header leaving document flow
      // This prevents page content from jumping up
      document.body.style.paddingTop = headerHeight + "px";
    }

    // 3) Show overlay - remove hidden, set inline styles to guarantee visibility
    overlay.removeAttribute("hidden");
    overlay.style.display = "block";
    overlay.style.opacity = "0";
    overlay.style.visibility = "visible";
    overlay.style.pointerEvents = "auto";
    
    // 4) Show drawer - remove hidden
    drawer.removeAttribute("hidden");
    drawer.style.display = "flex";
    
    // Force reflow
    void overlay.offsetWidth;
    void drawer.offsetWidth;

    // 5) Animate in
    requestAnimationFrame(() => {
      overlay.style.opacity = "1";
      overlay.classList.add("is-open");
      
      requestAnimationFrame(() => {
        drawer.classList.add("is-open");
      });
    });

    triggers.forEach((t) => t.classList.toggle("is-active", t === triggerEl));
    setExpanded(true);
  };

  const reset = () => {
    stack.length = 0;
    if (bodyPanel) bodyPanel.innerHTML = rootHTML;
    if (backRow) backRow.hidden = true;
  };

  const close = () => {
    // Animate out
    drawer.classList.remove("is-open");
    overlay.style.opacity = "0";
    overlay.classList.remove("is-open");
    
    triggers.forEach((t) => t.classList.remove("is-active"));
    setExpanded(false);

    // Wait for animation to complete before cleaning up
    setTimeout(() => {
      // Remove menu-open from header and clear inline styles
      const header = document.querySelector(".section-header");
      if (header) {
        header.classList.remove("menu-open");
        header.style.position = "";
        header.style.top = "";
        header.style.left = "";
        header.style.right = "";
        header.style.transform = "";
        header.style.visibility = "";
        header.style.zIndex = "";
      }
      
      // Remove body padding that compensated for fixed header
      document.body.style.paddingTop = "";
      
      document.documentElement.classList.remove("bb-meta-menu-lock");
      document.documentElement.style.removeProperty("--bb-scrollbar-gap");
      
      // Hide overlay and drawer
      overlay.style.display = "";
      overlay.style.opacity = "";
      overlay.style.visibility = "";
      overlay.style.pointerEvents = "";
      overlay.setAttribute("hidden", "");
      
      drawer.style.display = "";
      drawer.setAttribute("hidden", "");
      
      reset();
    }, 280);
  };

  triggers.forEach((t) => {
    t.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      open(t);
    });
  });

  closeBtn?.addEventListener("click", close);
  
  overlay.addEventListener("click", (e) => {
    e.preventDefault();
    close();
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && !drawer.hasAttribute("hidden")) close();
  });

  const pushPanelFromTemplate = (tpl) => {
    if (!bodyPanel) return;
    stack.push(bodyPanel.innerHTML);
    bodyPanel.innerHTML = tpl.innerHTML;
    if (backRow) backRow.hidden = false;

    const scroller = drawer.querySelector(".bb-meta-menu-body");
    if (scroller) scroller.scrollTop = 0;
  };

  drawer.addEventListener("click", (e) => {
    const mainLink = e.target.closest(".bb-meta-menu-link-main");
    if (!mainLink) return;

    const li = mainLink.closest(".bb-meta-menu-item[data-mm-meta]");
    if (!li) return;

    const hasPanel = li.dataset.mmHasPanel === "true";
    if (!hasPanel) return;

    e.preventDefault();
    const tpl = li.querySelector("template.bb-meta-menu-panel-template");
    if (!tpl) return;
    pushPanelFromTemplate(tpl);
  });

  backBtn?.addEventListener("click", () => {
    const prev = stack.pop();
    if (typeof prev !== "string") return;

    if (bodyPanel) bodyPanel.innerHTML = prev;
    if (stack.length === 0 && backRow) backRow.hidden = true;

    const scroller = drawer.querySelector(".bb-meta-menu-body");
    if (scroller) scroller.scrollTop = 0;
  });
})();
